import axios from "axios";
export default {
  data() {
    return {
      tenantId: this.realm,
      export: "",
      apiUrl: "",
      statusColors: {
        notrunning: "secondary",
        running: "success",
        pending: "warning",
        deployed: "info",
        failed: "error",
        terminating: "warning",
        updating: "blue-grey",
        unknown: "grey",
      },
    };
  },
  created() {
    this.apiUrl = this.mfConfig.api;
    this.getFlowsList();
    this.getMashupsList();
  },

  methods: {
    //Check the state and add a style class to improve chip rendering
    isOutlined(status) {
      return this.setStyle(status) ? "outlinedStyle" : "";
    },
    //Checks if status is 'not-running' or 'unknown' to apply outline style
    setStyle(status) {
      return status === "not-running" || status == "unknown" ? true : false;
    },
    //Assign a color to each state
    setColorStatus(status) {
      status = status.replace("-", "");
      return this.statusColors[status];
    },
    getFlowsList() {
      this.loader = true;
      axios
        .get(this.apiUrl + "/" + this.tenantId + "/flows", this.opts)
        .then((response) => {
          this.flows = response.data;
          this.loader = false;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.setError(error, false);
          }
          this.loader = false;
        });
    },
    getMashupsList() {
      axios
        .get(
          this.apiUrl + "/" + this.tenantId + "/projects?onlyReleased=true",
          this.opts,
        )
        .then((response) => {
          this.mashups = response.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.setError(error, false);
          }
        });
    },
    getMashupVersion() {
      const mashup = this.mashups.filter(
        (item) => item._id === this.editedItem._id,
      );
      this.editedItem.latestRelease = mashup[0].latestRelease;
    },
    //CREATE FLOW
    createFlow(formData) {
      this.loader = true;
      axios
        .post(this.apiUrl + "/" + this.tenantId + "/flows", formData, this.opts)
        .then(() => {
          this.getFlowsList();
        })
        .catch((error) => {
          this.setError(error, false);
          this.loader = false;
        });
    },
    createFlowConfirm() {
      if (this.validateCreateForm()) {
        const formData = new FormData();
        formData.append(
          "flow",
          JSON.stringify({
            version: this.editedItem.latestRelease,
            project: this.editedItem.project,
            name: this.editedItem.name,
          }),
        );
        this.createFlow(formData);
        this.closeCreateFlow();
      }
    },
    validateCreateForm() {
      return this.$refs.createForm.validate();
    },
    closeCreateFlow() {
      this.dialogCreate = false;
      this.resetDialog();
      this.$refs.createForm.resetValidation();
    },
    //DELETE FLOW
    deleteFlow(item) {
      if (item.owner !== this.loggedUserId) {
        return;
      }
      this.editedIndex = this.flows.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteMultipleFlow() {
      const hasNotOwnedSelection = this.selected.some((id) => {
        const item = this.flows.find((el) => el._id === id);
        return item ? item.owner !== this.loggedUserId : false;
      });
      if (hasNotOwnedSelection || this.selected.length === 0) {
        return;
      }
      this.dialogDelete = true;
      this.numDelete = 2;
    },
    deleteConfirm() {
      this.numDelete > 1
        ? this.deleteMultipleFlowConfirm()
        : this.deleteFlowConfirm();
    },

    deleteFlowConfirm() {
      this.loader = true;
      axios
        .delete(
          this.apiUrl + "/" + this.tenantId + "/flows/" + this.editedItem._id,
          this.opts,
        )
        .then(() => {
          this.flows.splice(this.editedIndex, 1);
          this.getFlowsList();
        })
        .catch((error) => {
          this.setError(error, false);
          this.loader = false;
        });
      this.closeDeleteFlow();
    },
    closeDeleteFlow() {
      this.dialogDelete = false;
      this.resetDialog();
    },

    deleteMultipleFlowConfirm() {
      this.loader = true;
      let ids = this.extractFlowsId();
      axios
        .delete(this.apiUrl + "/" + this.tenantId + "/flows", {
          params: {
            ids,
          },
          ...this.opts,
        })
        .then(() => {
          this.getFlowsList();
        })
        .catch((error) => {
          this.setError(error, false);
          this.loader = false;
        });
      this.closeDeleteFlow();
    },

    extractFlowsId() {
      let ids = [];
      this.selected.forEach((el) => {
        ids.push(el);
      });
      return ids;
    },

    //EXPORT FLOW
    exportFlow(item) {
      this.overlay = true;
      this.editedItem = Object.assign({}, item);
      axios
        .get(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/flows/" +
            this.editedItem._id +
            "/export",
          this.opts,
        )
        .then((response) => {
          this.downloadMashup(response.data, this.editedItem.name);
          this.editedItem = Object.assign({}, this.defaultItem);
          this.overlay = false;
        })
        .catch((error) => {
          this.setError(error, false);
          this.overlay = false;
        });
    },
    downloadMashup(exportObj, exportName) {
      let fileURL = window.URL.createObjectURL(
        new Blob([JSON.stringify(exportObj)]),
        {
          type: "application/json",
        },
      );
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", exportName + ".json");
      fileLink.click();
      fileLink.remove();
      this.overlay = false;
    },
    //Duplicate flow
    duplicateFlowProject(item) {
      this.editedIndex = this.flows.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDuplicate = true;
    },
    duplicateFlowConfirm() {
      this.duplicateFlow();
      this.closeDuplicateFlow();
    },
    duplicateFlow() {
      this.loader = true;
      axios
        .post(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/flows/" +
            this.editedItem._id +
            "/duplicate",
          {},
          this.opts,
        )
        .then(() => {
          this.getFlowsList();
        })
        .catch((error) => {
          this.setError(error, false);
          this.loader = false;
        });
    },
    closeDuplicateFlow() {
      this.dialogDuplicate = false;
      this.resetDialog();
    },

    //RESET variables
    resetDialog() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.numDelete = 1;
      });
    },

    //Open selected flow details (change page)
    routeToFlow(item) {
      this.$router.push({
        path: `/flow-editor/` + item._id,
      });
    },
    activateSnackbar(val, text) {
      this.snackbar = val;
      this.snackbarText = text;
    },
  },
};
